if (!customElements.get('card-block-shipping')) {
    customElements.define(
        'card-block-shipping',
        class CardBlockShipping extends HTMLElement {
            constructor() {
                super();
                this.tabElements = [];
                const sectionId = this.dataset.sectionId,
                    blockId = this.dataset.blockId,
                    vicEleContentTab = document.querySelectorAll(
                        `[data-tab-click="tab-${sectionId}-${blockId}-click-shipping"]`
                    ),
                    nswEleContentTab = document.querySelectorAll(
                        `[data-tab-click="tab-${sectionId}-${blockId}-click-depot"]`
                    );

                if (vicEleContentTab.length) {
                    vicEleContentTab.forEach(elem => {
                        this.tabElements.push(elem)
                    })
                }
                if (nswEleContentTab.length) {
                    nswEleContentTab.forEach(elem => {
                        this.tabElements.push(elem)
                    })
                }
            }
            connectedCallback() {
                this.events()
            }
            disconnectedCallback() {
                if (this.tabElements.length) {
                    this.tabElements.forEach(element => {
                        if (!element) return;
                        const self = this;
                        element.removeEventListener('click', function(event) {});
                    })
                }
            }

            events() {
                if (this.tabElements.length) {
                    this.tabElements.forEach(element => {
                        if (!element) return;
                        const self = this;
                        element.addEventListener('click', function(event) {
                            self.toggleTab(event, element);
                        });
                    });
                }
            }

            toggleTab(event, element) {
                const parent = element.parentElement;
                parent.classList.toggle('open');
            }
        }
    )
}